import { FC } from 'react'
import { useBreakpoints } from '@obeta/data/lib/hooks'
import { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { MediaContentTypes } from '../../types'
import { MediaItemsPanelDesktopView } from './MediaItemsPanelDesktopView'
import { MediaItemsPanelMobileView } from './MediaItemsPanelMobileView'
import styles from './MediaItemsSection.module.scss'

export type MediaItemsSectionProps = {
  itemsByGroup: Record<MediaContentTypes, ContentItem[]>
  onSetPreview: (itemIdx: number) => void
  activeContentTypeFilter: MediaContentTypes
  activeItemIndex: number
}

export const MediaItemsSection: FC<MediaItemsSectionProps> = ({
  activeItemIndex,
  itemsByGroup,
  onSetPreview,
  activeContentTypeFilter,
}) => {
  const { desktop } = useBreakpoints()

  return (
    <div className={styles.mediaItemsPanel}>
      {desktop ? (
        <MediaItemsPanelDesktopView
          activeItemIndex={activeItemIndex}
          onSetPreview={onSetPreview}
          itemsByGroup={itemsByGroup}
          activeContentTypeFilter={activeContentTypeFilter}
        />
      ) : (
        <MediaItemsPanelMobileView
          activeItemIndex={activeItemIndex}
          onSetPreview={onSetPreview}
          activeGroupItems={itemsByGroup[activeContentTypeFilter]}
          activeContentTypeFilter={activeContentTypeFilter}
        />
      )}
    </div>
  )
}
